import { MailSortingPage } from "@/components/features/mail-sorting/MailSortingPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/mail-sorting")({
  component: MailSortingPage,
});
